import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { BrandVideo } from "@/components/landing/BrandVideo";
import { Services } from "@/components/landing/Services";
import { CountdownTimer } from "@/components/landing/CountdownTimer";
import { Menu } from "@/components/landing/Menu";
import { About } from "@/components/landing/About";
import { Features } from "@/components/landing/Features";
import { Reviews } from "@/components/landing/Reviews";
import { Process } from "@/components/landing/Process";
import { BlackFriday } from "@/components/landing/BlackFriday";
import { Raffle } from "@/components/landing/Raffle";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-black text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <BrandVideo />
        <Services />
        <CountdownTimer />
        <Menu />
        <About />
        <Features />
        <Reviews />
        <Process />
        <BlackFriday />
        <Raffle />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
